import { SelectField } from "$components/inputs";
import { SelectField as RHFSelectField } from "$components/rhf-fields";
import React from "react";
import { useFacilityLocations } from "./use-facility-locations";

type Props = {
  value: string | null;
  id: string;
  "data-testid"?: string;
  label: string;
  onChange: (locationId: string | null) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: string;
};

export const LocationSelect: React.FunctionComponent<Props> = ({
  id,
  value,
  onChange,
  label,
  onBlur,
  onFocus,
  error,
  ...props
}: Props) => {
  const { data: locations, loading } = useFacilityLocations();

  const options =
    locations?.map(({ _id, name }) => ({
      value: _id,
      label: name,
    })) ?? [];

  return (
    <SelectField
      name="location"
      id={id}
      data-testid={id || props["data-testid"]}
      fullWidth
      required
      label={label}
      options={options}
      error={error}
      selectProps={{
        "data-testid": "receive-location-select",
        value,
        disabled: loading,

        onChange: (e: React.ChangeEvent<{ value: string }>) =>
          onChange(e.target.value),
        onBlur,
        onFocus,
        required: true,
      }}
    />
  );
};

LocationSelect.defaultProps = {
  onFocus: undefined,
  onBlur: undefined,
};

interface RHFProps {
  id: string;
  label: string;
}

export const RHFLocationSelect: React.FunctionComponent<RHFProps> = ({
  id,
  label,
}: RHFProps) => {
  const { data: locations, loading, error } = useFacilityLocations();

  const options =
    locations?.map(({ _id, name }) => ({
      value: _id,
      label: name,
    })) ?? [];

  return (
    <RHFSelectField
      name="locationId"
      id={id}
      data-testid={id}
      fullWidth
      required
      label={label}
      options={options || []}
      selectProps={{ disabled: loading || locations?.length === 0 }}
      error={error?.message}
      helperText={error?.message}
    />
  );
};
